import React, { useState } from "react";

import Button from "src/components/Button/Button";
import Checkbox from "src/components/Checkbox/Checkbox";

import styles from "../JudgeScheduleBuilder.module.scss";

export interface PickerRing {
  showId: string;
  showLabel: string;
  ring: string;
}

interface IProps {
  title: string;
  rings: PickerRing[];
  ringOnly?: boolean;
  trialOnly?: boolean;
  confirmLabel?: string;
  onPick: (showId: string, ring: string) => void;
  onCancel: () => void;
}

const RingTrialPicker: React.FC<IProps> = ({ title, rings, ringOnly, trialOnly, confirmLabel = "Continue", onPick, onCancel }) => {
  const [selected, setSelected] = useState(rings.length === 1 ? `${rings[0].showId}::${rings[0].ring}` : "");

  return (
    <div className={styles.form}>
      <h3>{title}</h3>
      <div className={styles.pickerList}>
        {rings.map((ring, index) => {
          const id = `${ring.showId}::${ring.ring}`;
          return (
            <Checkbox
              key={id}
              id={`jsb-ring-${index}`}
              label={trialOnly ? ring.showLabel : ringOnly ? ring.ring : `${ring.showLabel} · ${ring.ring}`}
              value={selected === id}
              onChange={() => setSelected(id)}
            />
          );
        })}
      </div>
      <div className={styles.formActions}>
        <Button variant="secondary" onClick={onCancel}>Cancel</Button>
        <Button disabled={!selected} onClick={() => {
          const [showId, ring] = selected.split("::");
          onPick(showId, ring);
        }}>{confirmLabel}</Button>
      </div>
    </div>
  );
};

export default RingTrialPicker;
